import { render } from "./RutaPagina.vue?vue&type=template&id=54e4dad6&scoped=true"
import script from "./RutaPagina.vue?vue&type=script&lang=js"
export * from "./RutaPagina.vue?vue&type=script&lang=js"

import "./RutaPagina.vue?vue&type=style&index=0&id=54e4dad6&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54e4dad6"]])

export default __exports__